import { NotificationSource } from "./notificationSource";

export enum NotificationState {
    Created = 0,
    Notified = 1,
    Confirmed = 2,
}

export interface NotificationListItemDto {
    notificationId: string;
    ownerId: string;
    targetObjectType: string;
    targetObjectId?: string;
    relatedObjectType: string;
    relatedObjectId?: string;
    type: string;
    titleKey: string;
    messageKey: string;
    contextJson: string;
    state: NotificationState;
    source: NotificationSource;
    createdAt: string;
}
